export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-gray-100 dark:border-gray-800 py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-500 dark:text-gray-500">
          <div className="flex items-center gap-1.5 font-bold text-base text-gray-900 dark:text-white">
            <span>MainRel</span>
            <span className="w-1.5 h-1.5 rounded-full bg-blue-600 dark:bg-blue-400" />
            <span className="font-normal text-sm text-gray-500 dark:text-gray-500">Oy</span>
          </div>

          <p className="italic text-xs text-center max-w-sm">
            "Software quality is not just about testing. It's about humans, processes and attitude."
          </p>

          <div className="text-right text-xs">
            <div>Y-tunnus: 3466668-7</div>
            <div>© {year} MainRel Oy</div>
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <a
            href="#hero"
            className="text-xs text-gray-400 dark:text-gray-600 hover:text-gray-600 dark:hover:text-gray-400 transition-colors"
          >
            Takaisin ylös ↑
          </a>
        </div>
      </div>
    </footer>
  )
}
